import { useTranslation } from "react-i18next";
import { MenuItem, Select } from "@mui/material";

const LanguageSwitcher = ({ ...rest }) => {
  const { t: translation, i18n } = useTranslation(
    "components/languageSwitcher"
  );

  const changeLanguage = (event) => {
    i18n.changeLanguage(event.target.value);
  };

  return (
    <Select value={i18n.language} onChange={changeLanguage} {...rest}>
      <MenuItem value="en">{translation("english")}</MenuItem>

      <MenuItem value="fr">{translation("french")}</MenuItem>

      <MenuItem value="ar">{translation("arabic")}</MenuItem>
    </Select>
  );
};

export default LanguageSwitcher;
